import React from 'react' // eslint-disable-line no-unused-vars
import '../../ui-elements/Modals'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import CountryAwareComponent from '../CountryAwareComponent'
import { connect } from 'react-redux'
import '../../css/ui-elements/modals.css'
import StaticConfig from '../StaticConfig'

class GeneralRequests extends CountryAwareComponent {
  render () {
    const languageContent = this.props.pageContent.content
    const generalRequestsLink = StaticConfig.Context.ComponentConfig.generalRequestsLink

    return (
      <div>
        <Modal
          isOpen
          toggle={this.props.toggle}
          wrapClassName='modal-primary'
          size='default'
        >
          <ModalHeader toggle={this.props.toggle}>{languageContent.page.HOME.generalRequests}</ModalHeader>
          <ModalBody>
            <p className='text-center'>{languageContent.page.HOME.generalReqSub}.</p>
            <div className='modal-link'>
              <a
                data-tag='track-exit' data-analytics-text='Other Requests'
                className='btn btn-primary btn-block btn-rounded'
                style={{ whiteSpace: 'normal', wordBreak: 'break-all'}}
                href={languageContent.page.HOME.medicalInquiryMenu.generalRequestsLink}
                target='_blank'
                rel='noopener noreferrer'
              >
                {`${languageContent.continueTo} ${languageContent.page.HOME.medicalInquiryMenu.generalRequestsLink}`}
              </a>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

function mapStateToProps ({ pageContent }) { return { pageContent } }

export default connect(mapStateToProps)(GeneralRequests)



// WEBPACK FOOTER //
// ./src/mi-app/modals/GeneralRequests.js